export enum ETimelineType {
    TABLE,
    TIMELINE,
    EXPERIMENT
};